export default {
  unreadNotifications (state) {
    return state.notifications.filter(notification => notification.readAt === null)
  },
  hasUnreadNotifications (state) {
    return state.notifications.some(notification => notification.readAt === null)
  }
}



// WEBPACK FOOTER //
// ./~/vue-components/notifications/store/getters.js